/**
 * Desides if the list item and its content is visible and if its not visible returns the top scroll needed to make it visible
 * @returns top scroll in pixels or -1 if visible
 */
export const sideMenuListItemGetScrollTop = (
  listItemEl: HTMLElement,
  listItemContentEl: HTMLDivElement,
  scrollContainerEl: HTMLDivElement
): number => {
  let listItemHeight = 0;
  let listItemTop = 0;
  let listItemBottom = 0;
  if (listItemEl && listItemContentEl && scrollContainerEl) {
    listItemHeight = listItemEl.offsetHeight + listItemContentEl.offsetHeight;
    // listItemTop = listItemEl.offsetTop;
    /** Använder bottom - 5 så att det autofokuserade elementet inte ska hamna exakt längs med toppen */

    const listTop = listItemEl.getBoundingClientRect().top;
    listItemTop =
      listTop -
      scrollContainerEl.getBoundingClientRect().top +
      scrollContainerEl.scrollTop;
    listItemBottom = listItemTop + listItemHeight;
  }

  let scrollContainerHeight = 0;
  let scrollContainerScrollTop = 0;
  let scrollContainerScrollBottom = 0;
  if (scrollContainerEl) {
    scrollContainerHeight = scrollContainerEl.offsetHeight;
    scrollContainerScrollTop = scrollContainerEl.scrollTop;
    scrollContainerScrollBottom =
      scrollContainerScrollTop + scrollContainerHeight;
  }

  const isVisible =
    listItemTop >= scrollContainerScrollTop &&
    listItemBottom <= scrollContainerScrollBottom;

  if (!isVisible) {
    if (listItemHeight >= scrollContainerHeight) {
      return listItemTop;
    } else {
      return listItemBottom - scrollContainerHeight;
    }
  } else {
    return -1;
  }
};
